import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface RegularKekHsmListState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  requestId: string | null
  list: any[] | null
  total_count: number
}

const initialState: RegularKekHsmListState = {
  isLoading: false,
  error: null,
  httpStatus: null,
  requestId: null,
  list: null,
  total_count: 0
}

export const regularKekHsmListSlice = createSlice({
  name: 'regularKekHsmList',
  initialState,
  reducers: {
    regularKekHsmListLoadingAction: (state) => ({
      ...initialState,
      isLoading: true
    }),
    regularKekHsmListUpdateAction: (
      state,
      action: PayloadAction<{ requestId: string, httpStatus: number }>
    ) => ({
      ...initialState,
      isLoading: false,
      httpStatus: action.payload.httpStatus,
      requestId: action.payload.requestId
    }),
    regularKekHsmListErrorAction: (
      state,
      action: PayloadAction<{ errorMessage: string, httpStatus: number }>
    ) => ({
      ...initialState,
      isLoading: false,
      error: action.payload.errorMessage,
      httpStatus: action.payload.httpStatus
    })
  }
})

export const {
  regularKekHsmListLoadingAction,
  regularKekHsmListUpdateAction,
  regularKekHsmListErrorAction
} = regularKekHsmListSlice.actions

export default regularKekHsmListSlice.reducer
